import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout';
import BlogLayout from './layouts/BlogLayout';
//import AdminLayout from './admin/pages/AdminDashboard';
import AdminLayout from './admin/Dashboard/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
import PostList from './admin/pages/PostList';
import PostCreate from './admin/components/posts/PostForm';
import PostEdit from './admin/components/posts/PostForm';
import CategoryList from './admin/pages/Category';
import PostContentBlocks from './admin/components/posts/PostContentBlocks';
import LandingPage from './pages/LandingPage';
import UserList from './admin/pages/User';
import ContactList from './admin/pages/Contact';
//import BlogLayout  from './pages/BlogLayout'
import LoginPage from './pages/Login';
import SignupPage from './pages/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import './App.css';
import LanguageTranslator from './PublicUser/Pages/LanguageTranslator';
import ReactGA from "react-ga4";
import AnalyticsTracker from './components/Tools/AnalyticsTracker';
import LearningLayout from './PublicUser/Pages/learning';

import BlogsPage from './PublicUser/Pages/BlogsPage';
import BlogDetailsPage from './PublicUser/Pages/BlogDetailsPage';
import NotFound from './components/NotFound'
import Tools from './PublicUser/Pages/Tools'


//for google anyalitics
function App() {

  useEffect(() => {
    ReactGA.initialize("G-55W91N785M");
  }, []);

  return (
    <BrowserRouter>
     <AnalyticsTracker />
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="home" element={<LandingPage />} />
          <Route path="posts" element={<LandingPage />} />
          <Route path="landing" element={<LandingPage />} />

        </Route>

          <Route element = {<BlogLayout/>}>
             <Route path="blog" element={<BlogsPage />} />
             <Route path="/blog/:id" element={<BlogDetailsPage />} />
             <Route path="language-translator" element={<LanguageTranslator />} />
               <Route path="tools" element={<Tools />} />
          </Route>
          
          <Route path="learning-zone/:postId/:slug" element={<LearningLayout />} />
          <Route path="learning-zone" element={<LearningLayout />} />
        <Route path="/login" element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }/>
      
          <Route path="/signup" element={
            <PublicRoute>
            <SignupPage />
          </PublicRoute>
          }/>

        {/* Admin Routes */}
        <Route path="/admin" element={
          <ProtectedRoute adminOnly>
            <AdminLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="posts" element={<PostList />} />
          <Route path="posts/create" element={<PostCreate />} />
          <Route path="posts/edit/:id" element={<PostEdit />} />
          <Route path="posts/:postId/content" element={<PostContentBlocks />} />
          <Route path="categories" element={<CategoryList />} />
          <Route path="users" element={<UserList />} />
          <Route path="contact" element={<ContactList />} />
        </Route>


        <Route path="*" element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
